<template>
  <slot
    :metrics="metrics"
    :statistics="statistics"
  >
    <ul
      class="counter__ul"
      v-bind="$attrs"
      v-if="metrics.length && statistics"
    >
      <li
        class="counter__li"
        v-for="(metric, key) in metrics"
        :key="`metric_${key}`"
      >
        <slot
          name="header"
          :metric="metric"
        />

        <strong class="counter__value">
          <slot
            :name="metric.type || 'value'"
            :metric="metric"
            :statistic="statistics[metric.type]"
          >
            <app-date
              v-if="metric.type === 'date' && metric.date"
              :timestamp="metric.date"
              filter="differenceInCalendarDays"
            />

            <app-money
              v-else-if="metric.type === 'amount_collected'"
              :amount="statistics[metric.type]"
            />

            <template v-else-if="metric.type === 'sporting_statistics'">
              <slot
                :name="metric.sporting_statistics"
                :metric="metric"
                :statistics="statistics.sporting_statistics"
                :statistic="statistics.sporting_statistics[metric.sporting_statistics]"
              >
                <template v-if="metric.sporting_statistics === 'total_distance'">
                  <app-number :number="statistics.sporting_statistics?.to_km" />
                </template>

                <template v-else-if="metric.sporting_statistics === 'total_time'">
                  <app-number :number="statistics.sporting_statistics?.to_hours" />
                </template>

                <template v-else>
                  <app-number :number="statistics.sporting_statistics[metric.sporting_statistics]" />
                </template>
              </slot>
            </template>

            <template v-else-if="metric.type === 'custom'">
              {{ translate(metric.value) || 0 }}
            </template>

            <template v-else>
              <app-number :number="statistics[metric.type]" />
            </template>
          </slot>
        </strong>


        <p class="counter__text">
          <slot
            name="text"
            :metric="metric"
          >
            {{ translate(metric.text) }}
          </slot>
        </p>
      </li>
    </ul>
  </slot>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useClientStore } from '@/stores/ClientStore'
import { useI18n } from '@/vendors/i18n'
import { computed } from 'vue'

const AppMoney = defineAsyncComponent(() => import('&/atoms/AppMoney'))
const AppNumber = defineAsyncComponent(() => import('&/atoms/AppNumber'))
const AppDate = defineAsyncComponent(() => import('&/atoms/AppDate'))

const { metrics, query, stats } = defineProps({
  metrics: { type: Array, required: true },
  query: { type: Object, default: () => ({}) },
  stats: Object
})

const { translate } = useI18n()
const { getStatistics } = useClientStore()

const { statistics: data } = getStatistics({ query, dependencies: [metrics.length, !stats] })

const statistics = computed(() => stats || data.value)
</script>